import React from "react";
import Sidebar from "../../../components/Sidebar";
import ScheduleTimingComponent from "../../../components/sheduleTimings/SheduleTimingComponent";

function SheduleTimings() {
  return (
    <Sidebar>
      <ScheduleTimingComponent />
    </Sidebar>
  );
}

export default SheduleTimings;
